// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__iB8DX","ranges":"BmiRanges_ranges__hxhkn"};